import { reverse } from 'named-urls';

import routes from 'core/routes';
import { EntityModules, isRegisterEntityModule } from 'core/constants';

export const entityRecordPath = (entityType: string, uuid: string): string | undefined => {
  if (entityType === EntityModules.Audits) {
    return reverse(routes.dashboard.audits.forms.details, { formId: uuid });
  }

  return isRegisterEntityModule(entityType)
    ? reverse(routes.dashboard[entityType].details, { entityId: uuid })
    : undefined;
};
